<template>
  <div class="container">
    <Header
      :title="'Extra Information'"
      :details="
        'If you have any additional links to websites/articles or images that you would like to provide, we ask that you attach them below.'
      "
      :includeDisclaimer="false"
    />
    <div class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >If you would like to share any links, please provide them
            here.</strong
          >
          <br />
          <em>Each link should be separated by a space.</em>
        </label>
        <textarea
          class="form-control"
          rows="3"
          :value="values.links"
          @keyup="e => handleValueChanged('links', e.target.value)"
        />
      </div>
    </div>
    <div v-if="allowImages" class="row">
      <div class="col">
        <label class="col-form-label">
          <strong
            >If you would like to share any images, please provide them
            here.</strong
          >
        </label>
        <div v-for="(image, i) in values.images" :key="i" class="mb-2">
          <div class="row">
            <div class="col">
              <div class="custom-file">
                <input
                  type="file"
                  class="custom-file-input"
                  accept="image/*"
                  :files="[image]"
                  @change="
                    e =>
                      handleValueChanged(i, e.target.files[0], { image: true })
                  "
                />
                <div class="custom-file-label">
                  {{ image ? image.name : "Choose Image" }}
                </div>
              </div>
            </div>
            <div v-if="removeAdditionalImage && i !== 0" class="col-1">
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="() => removeAdditionalImage(i)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
        </div>
        <button
          v-if="addAdditionalImage"
          type="button"
          class="btn btn-secondary btn-sm"
          @click="addAdditionalImage"
        >
          Add Additional Image
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Application/SectionHeader";
import { SectionExtra } from "@/typings/application";

export default {
  name: "sectionExtra",
  components: {
    Header
  },
  props: {
    values: {
      type: SectionExtra,
      required: true,
      default: () => {
        return new SectionExtra();
      }
    },
    onValueChanged: {
      type: Function,
      required: true,
      default: () => {}
    },
    addAdditionalImage: {
      type: Function,
      required: false,
      default: () => {
        return null;
      }
    },
    removeAdditionalImage: {
      type: Function,
      required: false,
      default: () => {
        return null;
      }
    },
    allowImages: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    handleValueChanged(name, value, details) {
      if (details && details.image === true) {
        let images = [].concat(this.values.images);
        if (!!images[name] && !value) {
          // Prevent image from being remove if user cancels file select dialog.
          return;
        }
        images[name] = value;
        this.onValueChanged("extra", "images", images);
      } else {
        this.onValueChanged("extra", name, value);
      }
    }
  }
};
</script>

<style></style>
